// Formata o valor da célula do CustomGrid conforme col.format
// ("BRL", "dd/MM/yyyy", "dd/MM/yyyy HH:mm:ss").
export const formatValue = (value, format) => {
  if (value == null) return "";
  if (!format) return String(value);

  if (format === "BRL") {
    const number = typeof value === "number" ? value : parseFloat(value);
    if (isNaN(number)) return value;
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(number);
  }

  const date = new Date(value);
  if (!isNaN(date)) {
    const pad = (n) => String(n).padStart(2, "0");
    return format
      .replace("dd", pad(date.getDate()))
      .replace("MM", pad(date.getMonth() + 1))
      .replace("yyyy", date.getFullYear())
      .replace("HH", pad(date.getHours()))
      .replace("mm", pad(date.getMinutes()))
      .replace("ss", pad(date.getSeconds()));
  }
  return String(value);
};
